<template>
	<v-form @keydown.enter.prevent>
		<v-container v-if="isEdit">
			<v-layout row wrap>
				<v-flex xs12 md6>
					<v-text-field ref="defaultFocusElement" v-model.trim="value.firstName" :error-messages="firstNameErrors" required>
						<template slot="label">First Name<span class="required">*</span></template>
					</v-text-field>
				</v-flex>
				<v-flex xs12 md6>
					<v-text-field v-model.trim="value.lastName" :error-messages="lastNameErrors" required>
						<template slot="label">Last Name<span class="required">*</span></template>
					</v-text-field>
				</v-flex>
				<v-flex xs12 md6>
					<v-text-field v-model.trim="value.middleName">
						<template slot="label">Middle Name</template>
					</v-text-field>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container v-else>
			<v-layout row wrap>
				<v-flex xs12 md6>
					<div class="form-group">
						<span class="form-label">First Name</span>
						<span class="form-value">{{ $_getFormValue('firstName') }}</span>
					</div>
				</v-flex>
				<v-flex xs12 md6
					><div class="form-group">
						<span class="form-label">Last Name</span>
						<span class="form-value">{{ $_getFormValue('lastName') }}</span>
					</div></v-flex
				>
				<v-flex xs12 md6>
					<div class="form-group">
						<span class="form-label">Middle Name</span>
						<span class="form-value">{{ $_getFormValue('middleName') }}</span>
					</div>
				</v-flex>
			</v-layout>
		</v-container>
	</v-form>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';
	import formMixin from '@/mixins/employeeFormMixin';

	export default {
		mixins: [validationMixin, formMixin],
		validations: {
			value: {
				firstName: { required },
				lastName: { required }
			}
		},
		computed: {
			firstNameErrors() {
				const errors = [];
				if (!this.$v.value.firstName.$dirty) return errors;
				!this.$v.value.firstName.required && errors.push('First Name is required.');
				return errors;
			},
			lastNameErrors() {
				const errors = [];
				if (!this.$v.value.lastName.$dirty) return errors;
				!this.$v.value.lastName.required && errors.push('Last Name is required.');
				return errors;
			}
		}
	};
</script>
